const shareBtn = document.querySelectorAll('.btn-share')
const windowUrl = window.location.href
const dummyClipboard = document.createElement('input')
dummyClipboard.setAttribute('id','clipboard')
if(shareBtn.length){
    shareBtn.forEach(item => {
        item.addEventListener('click', event => {
 
            if (navigator.share) {
                navigator.share({
                    title: item.getAttribute('aria-label'),
                    url: windowUrl
                })
            }else{
                document.body.appendChild(dummyClipboard);
                dummyClipboard.value = windowUrl;
                dummyClipboard.select();
                document.execCommand('copy');
                document.body.removeChild(dummyClipboard);
                item.classList.add('tooltip')
                setTimeout(() => {
                    item.classList.remove('tooltip')
                }, "3000")
            }
        })
    })
}